import React from 'react';

export const CalendarIcon = ({ width = 32, height = 32, color = "#CCCCCC", className }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 32 32"
            fill="none"
        >
            <path
                className={className}
                d="M9.33337 14.6667H12V17.3334H9.33337V14.6667ZM9.33337 20.0001H12V22.6667H9.33337V20.0001ZM14.6667 14.6667H17.3334V17.3334H14.6667V14.6667ZM14.6667 20.0001H17.3334V22.6667H14.6667V20.0001ZM20 14.6667H22.6667V17.3334H20V14.6667ZM20 20.0001H22.6667V22.6667H20V20.0001Z"
                fill={color}
            />
            <path
                className={className}
                d="M6.66667 29.3334H25.3333C26.804 29.3334 28 28.1374 28 26.6667V8.00008C28 6.52941 26.804 5.33341 25.3333 5.33341H22.6667V2.66675H20V5.33341H12V2.66675H9.33333V5.33341H6.66667C5.196 5.33341 4 6.52941 4 8.00008V26.6667C4 28.1374 5.196 29.3334 6.66667 29.3334ZM25.3333 10.6667L25.3347 26.6667H6.66667V10.6667H25.3333Z"
                fill={color}
            />
        </svg>
    );
};